// frontend/src/hooks/useRewardTracking.js - Hook to track article reads and earn rewards

import { useState, useCallback } from 'react';
import authService from '../services/authService';

export const useRewardTracking = () => {
  const [toast, setToast] = useState(null);

  const trackArticleRead = useCallback(async (articleId) => {
    if (!authService.isAuthenticated()) {
      return; // Not logged in, no tracking
    }

    try {
      const response = await authService.trackArticleRead(articleId);
      console.log('Track article response:', response);

      if (response && response.success) {
        console.log('Dispatching balance update event with:', response.new_balance);

        // Show toast notification
        setToast({
          message: response.message,
          balance: response.new_balance
        });

        // Dispatch custom event to update AuthButton balance
        window.dispatchEvent(new CustomEvent('balanceUpdate', {
          detail: { balance: response.new_balance }
        }));

        // Auto-hide after 3 seconds
        setTimeout(() => setToast(null), 3500);
      } else {
        console.log('Response success was false or response was null');
      }
    } catch (error) {
      console.error('Error tracking article:', error);
    }
  }, []);

  return { trackArticleRead, toast, setToast };
};

export default useRewardTracking;